import React from "react";
import { breadcrumbs } from "../../common/breadcrumbs";
import { TopBanner } from "../../common/TopBanner";

export const organization = type => {
  return (
    <div className="container">
      {breadcrumbs(type, [{ href: "/voice2/", text: "お客様の声" }, { text: "法人・団体で利用する荷物置き場に" }])}
      
      <div className="organization">
        <h1 id="useCaseContentsHead"><span>法人・団体で利用する荷物置き場に</span></h1>
        <div className="useCaseImg"><img src="resource/img/static/voice2/organization/kv_04.jpg" alt="活用事例"/></div>
          <div id="useCaseVoiceArea">
            <div className="useCaseBox">
              <h2>サークル活動の用具置き場に</h2>
              <div className="useCaseBoxInfo">
                <p className="useCaseName">サークルで利用しているK様</p>
                <p className="useCaseText">
                  大学のサークル活動の際に使う用具や、機材がたくさんあり、部室に収まらない分を収納する場所を探していました。その時に、練習場所から近いハローストレージさんのトランクルームを見つけたため、活用させて頂くようになりました。今までは、それぞれの部員が担当ごとに用具を当番で持ち帰っていましたが、トランクルームを借りたことによって、重たい荷物も持って帰らなくてよくなり、とても便利になりました。使用料に関しても、みんなでシェアしているので、お得に借りれていると思います。
                </p>
              </div>
            </div>
          
          <div className="useCaseBox">
            <h2>職場の荷物置き場に</h2>
            <div className="useCaseBoxInfo">
              <p className="useCaseName">自営業のT様</p>
              <p className="useCaseText">
                自宅で、リンパセラピーのサロンを開業しています。事務所専用として使える部屋がなかったため、一部を仕切りで目隠しして使っていました。お店のレイアウトの関係もありますし、事務所専用に使える空間を作るために、トランクルームを借りることを思い付きました。トランクルームを借りてからは、自宅の職場スペースが大変快適になりました。急なお客様にも対応出来る様になったし、お店として使っていない時には、広々とした空間でテレビやビデオの鑑賞を楽しんでいます。
              </p>
            </div>
          </div>
          
          <div className="useCaseBox">
            <h2>使わない書類の収納に</h2>
            <div className="useCaseBoxInfo">
              <p className="useCaseName">仕事の書類を収納しているC様</p>
              <p className="useCaseText">
                建設関係の仕事をしているので、ひとつ現場が終わると次の現場が始まるまで、書類などの収納場所が必要でした。自宅がマンションのため、スペースがなく、使わない書類の収納場所にトランクルームを利用しています。以前は全ての書類を現場倉庫に収納していましたが、使わない書類を持ち込まずに済み、現場倉庫の空きスペースが出来ました。年々物が増えていくので大変助かっています。
              </p>
            </div>
          </div>
          
          <div className="useCaseBox">
            <h2>オークションの商品や在庫の管理に</h2>
            <div className="useCaseBoxInfo">
              <p className="useCaseName">オークションサイトをしているU様</p>
              <p className="useCaseText">
                アマゾンやYAHOOオークションによく出店をするのですが、出店する商品を収納するスペースは、専ら自宅の玄関や廊下。時には、山積みになり自宅スペースが圧迫されておりました。トランクルームはそういった、オークションの商品や在庫の管理に使用しております。今では、山積みだった物が必要最小限になり、自宅スペースがすっきりとしました。借りたところも、自宅から会社までの通勤経路上を選定したので、途中下車しても次のバスまでの２０分間で、出し入れができるなど、大変助かっています。
              </p>
            </div>
          </div>
        </div>

        <div id="pageTopAreaBottom">&nbsp;</div>

        <div id="useCaseContentsLink">
          <h2>その他の活用事例</h2>
          <ul>
            <li><a href="/voice2/moving/"><img src="resource/img/static/voice2/organization/use_case_01.jpg" alt=""/><span>詳細はこちら</span></a><div className="useCaseContentsLinkBtn"><a href="/voice2/moving/"><span>引越し・リフォームの際の一時収納に</span></a></div></li>
            <li><a href="/voice2/season/"><img src="resource/img/static/voice2/organization/use_case_02.jpg" alt=""/><span>詳細はこちら</span></a><div className="useCaseContentsLinkBtn"><a href="/voice2/season/"><span>季節外用品・育児用品の収納に</span></a></div></li>
            <li><a href="/voice2/hobby/"><img src="resource/img/static/voice2/organization/use_case_03.jpg" alt=""/><span>詳細はこちら</span></a><div className="useCaseContentsLinkBtn"><a href="/voice2/hobby/"><span>趣味・コレクションの収納に</span></a></div></li>
            <li><a href="/voice2/organization/"><img src="resource/img/static/voice2/organization/use_case_04.jpg" alt=""/><span>詳細はこちら</span></a><div className="useCaseContentsLinkBtn"><a href="/voice2/organization/"><span>法人・団体の荷物収納に</span></a></div></li>
          </ul>
        </div>
        <p className="useCaseTextLink"><a href="/voice2/">⇒ お客様の声をみる</a></p>

        <div id="useCasePrefecturalLink">
          <a href="/">
            <div id="useCasePrefecturalLinkTitle"><img src="resource/img/static/voice2/organization/use_case_cv_area_copy.png" alt=""/></div>
            <div id="useCasePrefecturalLinkButton">近くのトランクルームを探す</div>
          </a>
        </div>
      </div>
    </div >
  );
};



// WEBPACK FOOTER //
// ./pages/new/organization.jsx